import sgMail from "@sendgrid/mail";

const senderEmailAddress = (process.env.SENDGRID_EMAIL as string) || "noreply@caresuite.email";
const senderName = "Caresuite";

const sendgridAPIKey = process.env.SENDGRID_API_KEY as string;

export type SendGridEmailAttachment = {
  filename: string;
  type: string;
  content: string;
};

type Props = {
  address: string;
  template?: string;
  sender?: string;
  email?: string | null;
  subject?: string;
  text?: string;
  attachments?: SendGridEmailAttachment[];
};

export const validateEmailAddress = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const sendEmail = async ({ address, template, sender, email, subject, text, attachments }: Props) => {
  sgMail.setApiKey(sendgridAPIKey);

  try {
    if (!validateEmailAddress(address)) throw new Error("Invalid Email address.");

    const attachmentPayload =
      attachments?.map((a) => ({
        content: a.content,
        filename: a.filename,
        type: a.type,
        disposition: "attachment" as const,
      })) ?? [];

    const msg = template
      ? {
          subject: subject || "Payment Notification",
          from: {
            email: email || senderEmailAddress,
            name: sender || senderName,
          },
          to: address,
          html: template,
          ...(attachmentPayload.length ? { attachments: attachmentPayload } : {}),
        }
      : {
          subject: subject || "Payment Notification",
          from: {
            email: email || senderEmailAddress,
            name: sender || senderName,
          },
          to: address,
          text: text || "",
          ...(attachmentPayload.length ? { attachments: attachmentPayload } : {}),
        };

    return await sgMail.send(msg);
  } catch (error) {
    throw error;
  }
};
